import { apiInstance } from '@diamond/shared/utils';

export const getBankAccount = async (token: string, warehouse: string) => {
  const { data } = await apiInstance(token).get(
    `/bank-account?warehouse=${warehouse}`
  );
  return data.bank_account;
};
